export default "/assets/ever.svg";